import { render, staticRenderFns } from "./TopInfoAction.vue?vue&type=template&id=a146adaa&scoped=true&"
import script from "./TopInfoAction.vue?vue&type=script&lang=js&"
export * from "./TopInfoAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a146adaa",
  null
  
)

export default component.exports